// extracted by mini-css-extract-plugin
export default {"link":"AlertLink_link__7Nuqx"};